// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20fYP","footer":"styles_footer__1fh1f","passCodeTooltip":"styles_passCodeTooltip__VhkPK"};